import { createSelector } from "reselect";
import { operatorsSelector } from "../../data/operators/selectors";
import { getOperatorById } from "../../data/operators/utils";
import { allParkDetailsSelector } from "../../data/park/details/selectors";
import { getParkDetailsById } from "../../data/park/details/utils";
import { regionsSelector } from "../../data/regions/selectors";
import { getRegionById } from "../../data/regions/utils";
import { extraDataSelector, unitTypesSelector } from "../../data/unitTypes/selectors";
import { getAllUnitTypeDataById } from "../../data/unitTypes/utils";
import { previousBookingParkIdSelector } from "../previousBooking/selector";
import { parkIdSelector, typeSelector, unitTypeIdSelector } from "./selectors";

// Use either the bookingParkId or previousBookingParkId based on bookingType
export const bookingParkDetailsSelector = createSelector(
  [typeSelector, previousBookingParkIdSelector, parkIdSelector, allParkDetailsSelector],
  (bookingType, previousBookingParkId, bookingParkId, allParkDetails) => {
    const selectedParkId = bookingType === 'new' ? bookingParkId : previousBookingParkId;
    return getParkDetailsById(allParkDetails, selectedParkId);
  },
);

export const unitSelector = createSelector(
  extraDataSelector,
  unitTypesSelector,
  unitTypeIdSelector,
  (extraData, unitTypes, unitTypeId) => {
    return getAllUnitTypeDataById(unitTypes, extraData, unitTypeId);
  },
);

export const bookingRegionSelector = createSelector(regionsSelector, bookingParkDetailsSelector, (regions, park) => {
  return getRegionById(regions, park.regn);
});

export const bookingOperatorSelector = createSelector(operatorsSelector, bookingParkDetailsSelector, (operators, park) => {
  return park ? getOperatorById(operators, park.opId) : undefined;
});

export const shouldShowPartyFormSelector = createSelector(
  operatorsSelector,
  allParkDetailsSelector,
  parkIdSelector,
  (operators, allParkDetails, parkId) => operators?.[allParkDetails[parkId]?.opId]?.party === 'true',
);